import { Outlet } from "react-router-dom";
import AdminRouteLayout from "../../navigation/AdminRouteLayout";

const SubscriptionRoot = () => (
  <AdminRouteLayout>
    <Outlet />
  </AdminRouteLayout>
);

export default SubscriptionRoot;
